import type { FC } from 'react';
import { ProgressBar } from '@carbon/react';

import styles from './UsoDoEspaco.module.scss';

// QUANTO DO ESPAÇO JÁ FOI USADO: a `ProgressBar` do Carbon e, embaixo, o uso em texto de apoio.
// O texto não vai no `helperText` porque, com ele, a `ProgressBar` anuncia "Loading" (fixo, em
// inglês) ao leitor de tela, e aqui nada está carregando. Cheio, a barra e o texto ficam em erro.

export const UsoDoEspaco: FC<{ rotulo: string; percentual: number; cheio: boolean; texto: string }> = ({
  rotulo, percentual, cheio, texto,
}) => (
  <div>
    <ProgressBar label={rotulo} value={Math.max(0, Math.min(100, percentual))} max={100} status={cheio ? 'error' : 'active'} />
    <p className={cheio ? styles.cheio : styles.texto}>{texto}</p>
  </div>
);
